import type { App } from 'vue'
import { Cookies, Quasar } from 'quasar'
import langJa from 'quasar/lang/ja'

const config = {
  plugins: { Cookies }, // import Quasar plugins and add here
  lang: langJa,
  /*
  config: {
    brand: {
      // primary: '#e46262',
      // ... or all other brand colors
    },
    notify: {...}, // default set of options for Notify Quasar plugin
    loading: {...}, // default set of options for Loading Quasar plugin
    loadingBar: { ... }, // settings for LoadingBar Quasar plugin
    // ..and many more (check Installation card on each Quasar component/directive/plugin)
  }
  */
}

export const install = (app: App) => {
  app.use(Quasar, config)
}
